import AIAssistantPanel from './panel/aiAssistantPanel';

export { AIAssistantPanelEntryPoint } from './panel/aiAssistantPanelScope';

export default AIAssistantPanel;
